import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const FloatingContactButtons = () => {
  const [settings, setSettings] = useState({
    phone: '+250 783 044 172',
    whatsapp_number: '+250783044172'
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/settings/public`);
      setSettings(prev => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  // Format phone number for tel: link (remove spaces)
  const telNumber = settings.phone?.replace(/\s/g, '') || '+250783044172';
  
  // Format WhatsApp number (remove + and spaces)
  const whatsappNumber = settings.whatsapp_number?.replace(/[^0-9]/g, '') || '250783044172';

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = `tel:${telNumber}`;
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="group relative bg-[#25D366] hover:bg-[#20b859] text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={28} />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-dark-800 text-white text-sm px-3 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          WhatsApp
        </span>
      </button>

      {/* Call Button */}
      <button
        onClick={handleCallClick}
        className="group relative bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
        aria-label="Call Us"
      >
        <Phone size={28} />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-dark-800 text-white text-sm px-3 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Call Us
        </span>
      </button>
    </div>
  );
};

export default FloatingContactButtons;